import { useContext, useEffect } from 'react'
import { NavContext } from '../../context/global_context'
import ErrorCard from '../../components/common/ErrorCard'

const NotFound = () => {
  const [state, dispatch] = useContext(NavContext)
  useEffect(() => {
    dispatch({ type: 'header', data: { show_back_btn: false } })
  }, [])
  return <ErrorCard title={'Not Found'} sub_title={'Data Not Found 404!'} />
}

export default NotFound
